/**
 * 
 * @returns 
 */
export const useTracking = (defaultEvent) => {

    /**
     * 
     * @param {object} data 
     */
    function track (data) {
        if (typeof window !== 'undefined' && window.dataLayer) {
            if (!data.event) {
                data.event = defaultEvent
            }
            window.dataLayer.push(data)
        }
    }    

    return {
        track
    }
}